var map = {
	"./en.json": [
		8053,
		[
			8053
		]
	],
	"./faq-en.json": [
		2758,
		[
			2758
		]
	],
	"./faq-fr.json": [
		6917,
		[
			6917
		]
	],
	"./fr.json": [
		7222,
		[
			7222
		]
	],
	"./guides-en.json": [
		493,
		[
			493
		]
	],
	"./guides-fr.json": [
		1870,
		[
			1870
		]
	],
	"./guides-teasers-en.json": [
		5201,
		[
			5201
		]
	],
	"./guides-teasers-fr.json": [
		4682,
		[
			4682
		]
	],
	"./landing-pages-en.json": [
		2536,
		[
			2536
		]
	],
	"./landing-pages-fr.json": [
		3547,
		[
			3547
		]
	],
	"./landing-pages-teasers-en.json": [
		3576,
		[
			3576
		]
	],
	"./landing-pages-teasers-fr.json": [
		2411,
		[
			2411
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3382;
module.exports = webpackAsyncContext;